import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  .upload-info-text {
    font-size: 12px;
    line-height: 1.67;
    color: ${({ theme }) => theme.colors.gray.color};
  }

  p {
    margin-bottom: 24px;
  }

  .files-row {
    .file-row {
      border-radius: 4px;
      /* margin-bottom: 5px; */
      background-color: ${({ theme }) => theme.colors.primary.shades['96']};
      padding: 8px 8px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        display: block;
        font-size: 16px;
        line-height: 1.5;
        color: ${({ theme }) => theme.colors.black.color};
        flex-grow: 1;
      }

      .delete-file {
        text-align: right;
        color: ${({ theme }) => theme.colors.primary.color};
        background: transparent;
        border: none;
      }
      .delete-file:hover {
        color: ${({ theme }) => theme.colors.error.color};
        cursor: pointer;
      }

      .text-file {
        padding-left: 10px;
        overflow-wrap: break-word;
      }

      img {
        border-radius: 4px;
        position: relative;
        max-width: 20%;
        max-height: 100px;
      }
    }
  }

  .first-row {
    display: flex;
    justify-content: flex-start;
    margin-top: 24px;

    .from-computer,
    .from-camera {
      display: flex;
      justify-content: space-around;
      padding-right: 16px;
    }

    .vertical-delimiter {
      width: 1px;
      opacity: 0.5;
      border: solid 1px ${({ theme }) => theme.colors.gray.color};
    }

    & > div {
      .right-side {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 16px;

        span {
          display: block;
          max-width: 215px;
          font-size: 16px;
          line-height: 1.5;
          color: #171b20;
        }

        button {
          margin-top: 16px;
          font-size: 14px;
          padding: 10px 20px;
        }
      }
    }

    .from-camera {
      margin-left: 5px;
    }
  }

  .second-row {
    margin-top: 32px;
    margin-bottom: 40px;
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    .upload-choice {
      display: flex;
      justify-content: space-around;
      align-items: center;
      /* flex-wrap: wrap; */

      height: 157px;
      width: 100%;
      margin-top: 24px;

      .camera-button-container {
        height: 100%;
        width: 157px;
      }

      .from-computer,
      .from-camera {
        height: 100%;
        width: 157px;
        border: solid 1px ${({ theme }) => theme.colors.primary.color};
        border-radius: 4px;
        margin: 15px;

        background-color: white;

        &:hover {
          background-color: ${({ theme }) => theme.colors.primary.shades['70']};
        }

        p {
          margin: 0;
          margin-top: 16px;
          text-align: center;
          font-family: Roboto;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          color: #ffffff;
          font-weight: 300;
        }
      }

      .from-computer {
        background-color: ${({ theme }) =>
          theme.buttons.primary.backgroundColor};
      }

      .from-camera {
        margin: 0;

        &:hover {
          background-color: white;
          // background-color: ${({ theme }) =>
            theme.colors.primary.shades['96']};
        }

        p {
          color: ${({ theme }) => theme.colors.primary.color};
        }
      }

      .centered {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      & > button:disabled {
        background-color: white;
        border: 1px solid ${({ theme }) => theme.colors.gray.color};
        pointer-events: none;

        p {
          color: ${({ theme }) => theme.colors.gray.color};
        }
      }
    }
  }
`;
